module.exports = __webpack_public_path__ + "img/電気回路_6_7_2.07669b22.png";